(() => {
  'use strict';

  const PN_TURNSTILE_SITE_KEY =
    '0x4AAAAAAFQSfZdl9oYRuZja';


  function ensureTurnstile(
    form,
    attempt = 0
  ) {

    const container =
      form?.querySelector(
        '[data-pnpw-turnstile]'
      );

    if (!container) return;

    if (
      container.dataset
        .pnTurnstileWidget !==
      undefined
    ) {
      return;
    }

    if (
      window.turnstile &&
      typeof window.turnstile.render ===
        'function'
    ) {

      const widgetId =
        window.turnstile.render(
          container,
          {
            sitekey:
              PN_TURNSTILE_SITE_KEY,
            size:
              'flexible',
            theme:
              'auto'
          }
        );

      container.dataset
        .pnTurnstileWidget =
          String(widgetId);

      return;
    }

    if (attempt < 80) {
      setTimeout(
        () =>
          ensureTurnstile(
            form,
            attempt + 1
          ),
        100
      );
    }

  }


  function captchaTokenFor(
    form
  ) {

    const container =
      form?.querySelector(
        '[data-pnpw-turnstile]'
      );

    const widgetId =
      container?.dataset
        ?.pnTurnstileWidget;

    if (
      widgetId === undefined ||
      !window.turnstile ||
      typeof window.turnstile
        .getResponse !==
        'function'
    ) {
      return '';
    }

    return String(
      window.turnstile.getResponse(
        widgetId
      ) || ''
    ).trim();

  }


  function resetTurnstileFor(
    form
  ) {

    const container =
      form?.querySelector(
        '[data-pnpw-turnstile]'
      );

    const widgetId =
      container?.dataset
        ?.pnTurnstileWidget;

    if (
      widgetId === undefined ||
      !window.turnstile ||
      typeof window.turnstile
        .reset !==
        'function'
    ) {
      return;
    }

    window.turnstile.reset(
      widgetId
    );

  }


  function waitForDB(callback, attempt = 0) {
    if (window.PeerNestDB) {
      callback();
      return;
    }

    if (attempt < 50) {
      setTimeout(
        () => waitForDB(callback, attempt + 1),
        100
      );
    }
  }


  function showMessage(
    root,
    text,
    type = 'error'
  ) {
    const message =
      root.querySelector(
        '[data-pnpw-message]'
      );

    if (!message) return;

    message.hidden = false;
    message.dataset.type = type;
    message.textContent = text;
  }


  function initForgotPassword() {
    const page =
      document.querySelector(
        '[data-pnpw-forgot]'
      );

    if (!page) return;

    const form =
      page.querySelector('form');

    const submit =
      form.querySelector(
        '[type="submit"]'
      );

    ensureTurnstile(
      form
    );

    form.addEventListener(
      'submit',
      async event => {
        event.preventDefault();

        submit.disabled = true;

        const email =
          String(
            new FormData(form)
              .get('email') || ''
          ).trim();

        try {

          const captchaToken =
            captchaTokenFor(
              form
            );

          if (!captchaToken) {
            throw new Error(
              'Please complete the security check.'
            );
          }

          await window.PeerNestDB
            .requestPasswordReset(
              email,
              window.location.origin +
              '/pages/reset-password?view=reset-password',
              captchaToken
            );

          showMessage(
            page,
            'If a PeerNest account exists for that email, a reset link has been sent.',
            'success'
          );

          form.reset();
        }

        catch (error) {
          showMessage(
            page,
            error.message ||
            'Unable to send the reset email.'
          );
        }

        finally {

          resetTurnstileFor(
            form
          );

          submit.disabled = false;
        }
      }
    );
  }


  async function initResetPassword() {
    const page =
      document.querySelector(
        '[data-pnpw-reset]'
      );

    if (!page) return;

    const form =
      page.querySelector('form');

    const submit =
      form.querySelector(
        '[type="submit"]'
      );

    try {
      if (
        window.location.hash &&
        window.location.hash
          .includes('access_token=')
      ) {
        window.PeerNestDB
          .consumeOAuthRedirect();
      }

      const session =
        await window.PeerNestDB
          .getSession();

      if (!session?.access_token) {
        throw new Error(
          'This password reset link is invalid or has expired.'
        );
      }
    }

    catch (error) {
      showMessage(
        page,
        error.message
      );

      form.hidden = true;
      return;
    }


    form.addEventListener(
      'submit',
      async event => {
        event.preventDefault();

        const data =
          new FormData(form);

        const password =
          String(
            data.get('password') || ''
          );

        const confirm =
          String(
            data.get('confirm_password') ||
            ''
          );

        if (password.length < 8) {
          showMessage(
            page,
            'Use at least 8 characters.'
          );
          return;
        }

        if (password !== confirm) {
          showMessage(
            page,
            'Passwords do not match.'
          );
          return;
        }

        submit.disabled = true;

        try {
          await window.PeerNestDB
            .updatePassword(
              password
            );

          await window.PeerNestDB
            .signOut();

          window.location.replace(
            '/pages/login?reset=success'
          );
        }

        catch (error) {
          showMessage(
            page,
            error.message ||
            'Unable to update your password.'
          );
        }

        finally {
          submit.disabled = false;
        }
      }
    );
  }


  waitForDB(() => {
    initForgotPassword();
    initResetPassword();
  });

})();
